import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { HistoryRouter as Router } from 'redux-first-history/rr6'
import ErrorBoundary from 'Hoc/ErrorBoundary'
import ScrollToTop from 'Hoc/ScrollToTop'
import MerchantProductFe from './MerchantProductFeContainer'
import { ListenerProvider } from 'Hoc/ListenerProvider'
import DeepLinkingManager from 'Hoc/DeepLinkingManager'
import 'Style/scss/main.scss'

const basename = process.env.PUBLIC_URL || ''

const MainContainer = ({ authRoutes, unauthRoutes, store, logged, history, ...rest }) => (
  <Provider store={store}>
    <Router history={history} basename={basename}>
      <DeepLinkingManager logged={logged} />
      <ListenerProvider>
        <ErrorBoundary>
          <ScrollToTop>
            <MerchantProductFe logged={logged} authRoutes={authRoutes} unauthRoutes={unauthRoutes} {...rest} />
          </ScrollToTop>
        </ErrorBoundary>
      </ListenerProvider>
    </Router>
  </Provider>
)

MainContainer.propTypes = {
  authRoutes: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func.isRequired
      })
    )
  ).isRequired,
  unauthRoutes: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func.isRequired
      })
    )
  ).isRequired,
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  logged: PropTypes.bool.isRequired
}

export default MainContainer
